/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_InstructionsInputs */

const en_us2_exercise_instructions = /** @type {(inputs: Exercise_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How to do it`)
};

const pt_br2_exercise_instructions = /** @type {(inputs: Exercise_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como fazer`)
};

const es_419_exercise_instructions = /** @type {(inputs: Exercise_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cómo hacerlo`)
};

const pt_pt2_exercise_instructions = /** @type {(inputs: Exercise_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como fazer`)
};

const fr_fr2_exercise_instructions = /** @type {(inputs: Exercise_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment faire`)
};

const de_de2_exercise_instructions = /** @type {(inputs: Exercise_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`So geht's`)
};

const it_it2_exercise_instructions = /** @type {(inputs: Exercise_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come eseguirlo`)
};

/**
* | output |
* | --- |
* | "How to do it" |
*
* @param {Exercise_InstructionsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_instructions = /** @type {((inputs?: Exercise_InstructionsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_InstructionsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_instructions(inputs)
	if (locale === "es-419") return es_419_exercise_instructions(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_instructions(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_instructions(inputs)
	if (locale === "de-DE") return de_de2_exercise_instructions(inputs)
	if (locale === "it-IT") return it_it2_exercise_instructions(inputs)
	return en_us2_exercise_instructions(inputs)
});
export { exercise_instructions as "exercise.instructions" }